import { styled } from "@mui/material/styles";

import ResponsiveImage from "components/ResponsiveImage";

export const Category = styled("div")(({ theme }) => ({
  position: "relative",
  display: "inline-block",
  "&::before": {
    content: "''",
    position: "absolute",
    left: 0,
    top: 0,
    width: "100%",
    height: "100%",
    opacity: 0,
    backgroundColor: theme.palette.primary.main,
    willChange: "opacity",
    transform: "opacity 0.1s cubic-bezier(0.25, 1, 0.5, 1)",
  },
  "&:hover::before": {
    opacity: 0.7,
  },
}));

export const StyledResponsiveImage = styled(ResponsiveImage)({
  maxWidth: "100%",
  height: "auto",
  display: "block",
});
